module.exports = __webpack_public_path__ + "static/media/Kathedraal.760e22db.jpg";